import { useEffect, useState } from "react";
import { X, Download, Loader2 } from "lucide-react";
import api from "@/api";

function previewUrlFor(url) {
  const m = url.match(/\/coach\/nutrition-plans\/([^/]+)\/pdf/);
  if (m) return `/nutrition-pdf-preview?plan_id=${m[1]}`;
  if (url.includes("/client/nutrition/pdf")) return "/nutrition-pdf-preview";
  return null;
}

export function PdfViewerModal({ url, title, onClose }) {
  const [pages, setPages] = useState(null);
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  const preview = url ? previewUrlFor(url) : null;

  useEffect(() => {
    setPages(null);
    if (!url || !isMobile || !preview) return;
    let alive = true;
    api.get(preview)
      .then((r) => { if (alive) setPages(r.data.pages || []); })
      .catch(() => { if (alive) setPages(null); });
    return () => { alive = false; };
  }, [url]);

  if (!url) return null;
  const showImages = isMobile && preview;
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex flex-col" data-testid="pdf-viewer-modal">
      <div className="flex items-center justify-between gap-2 px-4 pb-3 bg-[#1C181A] text-[#F5E6E8] shrink-0"
        style={{ paddingTop: "calc(0.75rem + env(safe-area-inset-top, 0px))" }}>
        <p className="font-bold text-sm truncate flex-1">{title}</p>
        <a href={url} download data-testid="pdf-download-link"
          className="inline-flex items-center gap-1.5 text-xs font-bold text-accent hover:opacity-80 shrink-0">
          <Download className="w-4 h-4" /> Scarica
        </a>
        <button onClick={onClose} data-testid="pdf-viewer-close"
          className="inline-flex items-center gap-1.5 text-xs font-black uppercase tracking-wide bg-primary text-primary-foreground rounded-full px-3.5 py-1.5 shrink-0">
          <X className="w-4 h-4" /> Chiudi
        </button>
      </div>
      {showImages ? (
        <div className="flex-1 overflow-y-auto bg-secondary/30 p-2 space-y-2" data-testid="pdf-image-viewer"
          style={{ paddingBottom: "calc(0.5rem + env(safe-area-inset-bottom, 0px))" }}>
          {pages === null && (
            <div className="h-full grid place-items-center text-muted-foreground">
              <Loader2 className="w-8 h-8 animate-spin" />
            </div>
          )}
          {pages && pages.map((src, i) => (
            <img key={i} src={src} alt={`Pagina ${i + 1}`} data-testid={`pdf-page-image-${i}`}
              className="w-full rounded-lg shadow-md" loading="lazy" />
          ))}
        </div>
      ) : (
        <iframe src={url} title={title} className="flex-1 w-full bg-white" />
      )}
    </div>
  );
}
